export interface issueCardInfo {
    rnn: string //실명번호
    mmbrNm: string //회원명
    mmbrEnsnNm: string //회원영문명
    mngmBrcd: string //관리부점코드
    smsClphSvcNo: string //SMS휴대폰서비스번호
    smsClphTon: string //SMS휴대폰국번호
    smsClphIncsNo: string //SMS휴대폰개별번호
    oohZpcd: string //자택우편번호
    oohZpcdBscAdr: string //자택우편번호기본주소
    oohZpcdDtlAdr: string //자택우편번호상세주소
    oohRdndDcd: string //자택도로명주소구분코드
    oohRdnmBscAdr: string //자택도로명기본주소
    oohRdnmDtlAdr: string //자택도로명상세주소
    oohBldnMngmNo: string //자택건물관리번호
    oohLln: string //자택지역번호
    oohTon: string //자택국번호
    oohIncsNo: string //자택개별번호
    wrplNm: string //직장명
    dvm: string //부서명
    wrplZpcd: string //직장우편번호
    wrplZpcdBscAdr: string //직장우편번호기본주소
    wrplZpcdDtlAdr: string //직장우편번호상세주소
    wrplRdndDcd: string //직장도로명주소구분코드
    wrplRdnmBscAdr: string //직장도로명기본주소
    wrplRdnmDtlAdr: string //직장도로명상세주소
    wrplBldnMngmNo: string //직장건물관리번호
    wrplLln: string //직장지역번호
    wrplTon: string //직장국번호
    wrplIncsNo: string //직장개별번호

    /** 비밀번호 Datakey
     * @type {string}
     */
    pwdDatakey: string

    /** 현금카드비밀번호 Datakey
     * @type {string}
     */
    cashPwdDatakey: string

    /** PIN비밀번호 Datakey
     * @type {string}
     */
    pinPwdDatakey: string

    /** 카드발송방법구분코드
     * @type {string}
     */
    cardSndgWayDcd: string

    cardSndgWayDcdNm: string //카드발송방법구분명 -- 화면 표기용

    /** 카드수령지구분코드
     * @type {string}
     */
    cardRcarDcd: string

    /** 카드수령지구분코드명
     * @type {string}
     */
    cardRcarDcdNm: string
    /**
     * @doc 카드수령부점코드 (CARD_RCEP_BRCD)
     */
    cardRcepBrcd: string

    /** 이메일주소
     * @type {string}
     */
    ead: string

    /** 대금청구지구분코드
     * @type {string}
     */
    mnpbAsarDcd: string

    /** 청구서발송방법코드
     * @type {string}
     */
    dmshSndgMcd: string

    /** 청구서발송방법명
     * @type {string}
     */
    dmshSndgMcdNm: string

    tratLmtnYn: string //계좌이체제한여부
    cscrStlmSvcYn: string //현금카드결제서비스여부
    valdDlnCd: string //유효기한코드

    /** 신용카드제휴코드
     * @type {string}
     */
    ccalCd: string //신용카드제휴코드

    /** 카드브랜드사구분코드
     * @type {string}
     */
    cardBrcoDcd: string

    /** 카드브랜드사내용
     * @type {string}
     */
    cardBrcoDnm: string

    cardGdcd: string //카드등급코드

    /** 교통카드구분코드
     * @type {string}
     */
    trcdDcd: string //교통카드구분코드
    trcdDcdNm: string //교통카드구분명 -- 화면 표기용

    /** 신카드디자인종류코드
     * @type {string}
     */
    nwCardDesgKcd: string //디자인종류코드

    stlmBncd: string //결제은행코드
    stlmAcn: string //결제계좌번호
    smsSrapYn: string //SMS서비스신청여부
    cardOfpsNo: string //카드모집인번호

    /** 신용정보이용동의여부
     * 따로 매핑안해됨(카드시스템이재정)
     * @type {string}
     */
    crifUtlCosnYn: string

    /** 고유식별정보이용동의여부
     * @type {string}
     */
    orriUtlCosnYn: string

    /** 신용정보제공동의여부
     * @type {string}
     */
    crdtInofrCosnYn: string

    /** 고유식별정보제공동의여부
     * 따로 매핑안해됨(카드시스템이재정)
     * @type {string}
     */
    orriOfrCosnYn: string

    /** 전자광고정보수신동의여부
     * @type {string}
     */
    elcrAdvsIfrcCosnYn: string

    /** 신용카드전화권유동의여부
     * @type {string}
     */
    crdTelSlcsYn: string

    /** 신용카드SMS권유동의여부
     * @type {string}
     */
    crdSmsSlcsYn: string

    /** 신용카드서면권유동의여부
     * @type {string}
     */
    crdInwrSlcsYn: string

    /** 신용카드이메일권유동의여부
     * @type {string}
     */
    crdEmlSlcsYn: string

    /** 상품이용권유동의여부
     * @type {string}
     */
    pdfUtlSlcsYn: string

    /** 상품부수서비스안내동의여부
     * @type {string}
     */
    pdfNmcpSrgnCosnYn: string

    /** 부정사용방지정보제공동의여부
     * @type {string}
     */
    ilusPrvnInfoOffsYn: string

    /** 모바일메세지 수신동의여부
     * @type {string}
     */
    mblMsgSvcCosnYn: string

    stlmDd: string //결제일
    edpsCsn: string //전산고객번호
    csacIdntNo: string //고객계좌식별번호
    bdsCd: string //사업부제코드
    csmnTeamCd: string //고객관리팀코드
    amslCstpSmsSndgDcd: string //매출건별SMS발송구분코드
    amslCstpSmsSndgDcdNm: string //매출건별SMS발송구분명 -- 화면 표기용
    spaeZpcd: string //별도청구지우편번호
    spaeZpcdBscAdr: string //별도청구지우편번호기본주소
    spaeZpcdDtlAdr: string //별도청구지우편번호상세주소
    spaeRdndDcd: string //별도청구지도로명주소구분코드
    spaeRdnmBscAdr: string //별도청구지도로명기본주소
    spaeRdnmDtlAdr: string //별도청구지도로명상세주소
    spaeBldnMngmNo: string //별도청구지건물관리번호
    spaeTelLln: string //별도청구지전화지역번호
    spaeTelTon: string //별도청구지전화국번호
    spaeTelIncsNo: string //별도청구지전화개별번호
    rcepAddr: string //수령지 -- 화면표기용
    stlmDdTxt: string //결재일 -- 화면표기용

    ftpmTrcdYc: string //후불교통카드선택

    nchInsnSvcYn: string //무료상해보험(청년동행카드용)NCH_INSN_SVC
    nchInsnSvcNm: string //무료상해보험선택 -- 화면표기용
    wbcsRlnmAltrNo: string //전행고객실명대체번호 -- 상태업데이트를 위해 필요
    trnYmd: string //거래년월일 -- 상태업데이트를 위해 필요
    trhsSrn: string //거래내역일련번호
    newCard: string
    pdlnCd: string
    pdgrCd: string
    transkeyUuidPwd: string //암호화 복호화처리용
    transkeyPwd: string //암호화 복호화처리용
    transkeyHmPwd: string //암호화 복호화처리용
    transkeyUuidCashPwd: string //암호화 복호화처리용
    transkeyCashPwd: string //암호화 복호화처리용
    transkeyHmCashPwd: string //암호화 복호화처리용
    transkeyUuidPinPwd: string //암호화 복호화처리용
    transkeyPinPwd: string //암호화 복호화처리용
    transkeyHmPinPwd: string //암호화 복호화처리용
    comboYn: string //콤보여부 Y/N
    brandNm: string //발급을위해선택한카드의브랜드구분
    studentCardYn: string //학생증카드여부 Y/N
    ovrsWonStlmCosnYn: string //해외원화결제 신청여부

    /**  체크카드 비밀번호와 동일하게 현금카드 비밀번호 적용여부
     * @type {boolean}
     */
    isChkCrdSamePwCshCrd: boolean

    /** 점자카드구분코드
     * @type {string}
     */
    brllCardDcd: string

    /** 간편결제서비스신청번호
     * @type {string}
     */
    simpStlmSrapNo: string

    /** 약관제공방법코드 STPL_OFR_MCD
     * @type {string}
     */
    stplOfrMcd: string

    /** 약관제공방법코드명
     * @type {string}
     */
    stplOfrMcdNm: string
	
	/** 제휴메모내용
	 * @type {string}
	 */
	alncMemoCon: string

    // ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓ TOBE ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓
    // ↑↑↑↑↑↑↑↑↑↑↑  ASIS - common.js IssueCardInfo에 없었음  ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑

    // 뒤로 가기 처리

    /** I-Travel 개인(신용)정보 필수적 전체 동의
     * @type {string}
     */

    iTravelArgee: boolean

    /**
     * @doc 국제학생증카드 타입 innnSccType
     * "N" 국제학생증카드 X, "ISIC" IBK Hola ISIC 국제 학생증카드
     */
    innnSccType: string

    /**
     * @doc 학생증카드 여부
     */
    sccYn: string

    /**
     * @doc 개인(신용)정보의 필수적 제공(제휴카드) 약관 노출 여부
     */
    isIdciMndrOfrCoccd?: boolean

    /**
     * @doc 카드 단일 디자인 여부
     */
    isSingleCardDesign?: boolean

    /**
     * @doc 카드 디자인 data
     */
    cardDesignData?: Array<{
        desgKcd: string
        desgKNm: string
        desgKSrc: string
    }>

    /**
     * @doc 후불교통카드 기능 여부
     */
    ftpmTrcdFuncYn: string

    /**
     * @doc 후불교통카드 기능 고정 여부
     */
    isFtpmTrcdYcFix: boolean

    /**
     * @doc 카드수령부점명
     */
    cardRcepBrNm: string

    /**
     * @doc 결제일
     */
    paymentDate: { isFix: boolean; stlmDd: string }

    /**
     * @doc 해외원화결제 필수 여부
     */
    isDccRequired: boolean

    /** 연회비(상세)
     * @type {string}
     */
    cardChrcPa305: string

    /** 카드 브랜드 data
     * @type {string}
     */
    cardInfoLc022List: [
        {
            /** 비대면채널조건값데이터내용 (브랜드명)
             * @type {string}
             */
            nfchCnvlDataCon: string
            /** 조건값데이터내용 (브랜드코드)
             * @type {string}
             */
            cnvlDataCon: string
        }
    ]
}

export const initialState: issueCardInfo = {
    rnn: '',
    mmbrNm: '',
    mmbrEnsnNm: '',
    mngmBrcd: '',
    smsClphSvcNo: '',
    smsClphTon: '',
    smsClphIncsNo: '',
    oohZpcd: '',
    oohZpcdBscAdr: '',
    oohZpcdDtlAdr: '',
    oohRdndDcd: '',
    oohRdnmBscAdr: '',
    oohRdnmDtlAdr: '',
    oohBldnMngmNo: '',
    oohLln: '',
    oohTon: '',
    oohIncsNo: '',
    wrplNm: '',
    dvm: '',
    wrplZpcd: '',
    wrplZpcdBscAdr: '',
    wrplZpcdDtlAdr: '',
    wrplRdndDcd: '',
    wrplRdnmBscAdr: '',
    wrplRdnmDtlAdr: '',
    wrplBldnMngmNo: '',
    wrplLln: '',
    wrplTon: '',
    wrplIncsNo: '',
    pwdDatakey: '',
    cashPwdDatakey: '',
    pinPwdDatakey: '',
    cardSndgWayDcd: '',
    cardSndgWayDcdNm: '',
    cardRcarDcd: '',
    cardRcarDcdNm: '',
    cardRcepBrcd: '',
    ead: '',
    mnpbAsarDcd: '',
    dmshSndgMcd: '',
    dmshSndgMcdNm: '',
    tratLmtnYn: '',
    cscrStlmSvcYn: '',
    valdDlnCd: '',
    ccalCd: '',
    cardBrcoDcd: '',
    cardBrcoDnm: '',
    cardGdcd: '',
    trcdDcd: '',
    trcdDcdNm: '',
    nwCardDesgKcd: '',
    stlmBncd: '',
    stlmAcn: '',
    smsSrapYn: '',
    cardOfpsNo: '',
    crifUtlCosnYn: '',
    orriUtlCosnYn: '',
    crdtInofrCosnYn: '',
    orriOfrCosnYn: '',
    elcrAdvsIfrcCosnYn: '',
    crdTelSlcsYn: '',
    crdSmsSlcsYn: '',
    crdInwrSlcsYn: '',
    crdEmlSlcsYn: '',
    pdfUtlSlcsYn: '',
    pdfNmcpSrgnCosnYn: '',
    ilusPrvnInfoOffsYn: '',
    mblMsgSvcCosnYn: '',
    stlmDd: '',
    edpsCsn: '',
    csacIdntNo: '',
    bdsCd: '',
    csmnTeamCd: '',
    amslCstpSmsSndgDcd: '',
    amslCstpSmsSndgDcdNm: '',
    spaeZpcd: '',
    spaeZpcdBscAdr: '',
    spaeZpcdDtlAdr: '',
    spaeRdndDcd: '',
    spaeRdnmBscAdr: '',
    spaeRdnmDtlAdr: '',
    spaeBldnMngmNo: '',
    spaeTelLln: '',
    spaeTelTon: '',
    spaeTelIncsNo: '',
    rcepAddr: '',
    stlmDdTxt: '',
    ftpmTrcdYc: '',
    nchInsnSvcYn: '',
    nchInsnSvcNm: '',
    wbcsRlnmAltrNo: '',
    trnYmd: '',
    trhsSrn: '',
    newCard: '',
    pdlnCd: '',
    pdgrCd: '',
    transkeyUuidPwd: '',
    transkeyPwd: '',
    transkeyHmPwd: '',
    transkeyUuidCashPwd: '',
    transkeyCashPwd: '',
    transkeyHmCashPwd: '',
    transkeyUuidPinPwd: '',
    transkeyPinPwd: '',
    transkeyHmPinPwd: '',
    comboYn: '',
    brandNm: '',
    isChkCrdSamePwCshCrd: false,
    brllCardDcd: '',
    simpStlmSrapNo: '',
    stplOfrMcd: '',
    stplOfrMcdNm: '',
	alncMemoCon: '',
    iTravelArgee: false,

    innnSccType: '',
    sccYn: '',
    isIdciMndrOfrCoccd: false,
    isSingleCardDesign: false,
    cardDesignData: [
        {
            desgKcd: '',
            desgKNm: '',
            desgKSrc: '',
        },
    ],
    ftpmTrcdFuncYn: '',
    isFtpmTrcdYcFix: false,
    cardRcepBrNm: '',
    paymentDate: {
        isFix: false,
        stlmDd: '',
    },
    isDccRequired: false,
    studentCardYn: '',
    ovrsWonStlmCosnYn: '',
    cardChrcPa305: '',
    cardInfoLc022List: [
        {
            nfchCnvlDataCon: '',
            cnvlDataCon: '',
        },
    ],
}

export const initIssueCardInfo: issueCardInfo = {
    rnn: '',
    mmbrNm: '',
    mmbrEnsnNm: '',
    mngmBrcd: '',
    smsClphSvcNo: '',
    smsClphTon: '',
    smsClphIncsNo: '',
    oohZpcd: '',
    oohZpcdBscAdr: '',
    oohZpcdDtlAdr: '',
    oohRdndDcd: '',
    oohRdnmBscAdr: '',
    oohRdnmDtlAdr: '',
    oohBldnMngmNo: '',
    oohLln: '',
    oohTon: '',
    oohIncsNo: '',
    wrplNm: '',
    dvm: '',
    wrplZpcd: '',
    wrplZpcdBscAdr: '',
    wrplZpcdDtlAdr: '',
    wrplRdndDcd: '',
    wrplRdnmBscAdr: '',
    wrplRdnmDtlAdr: '',
    wrplBldnMngmNo: '',
    wrplLln: '',
    wrplTon: '',
    wrplIncsNo: '',
    pwdDatakey: '',
    cashPwdDatakey: '',
    pinPwdDatakey: '',
    cardSndgWayDcd: '',
    cardSndgWayDcdNm: '',
    cardRcarDcd: '',
    cardRcarDcdNm: '',
    cardRcepBrcd: '',
    ead: '',
    mnpbAsarDcd: '',
    dmshSndgMcd: '',
    dmshSndgMcdNm: '',
    tratLmtnYn: '',
    cscrStlmSvcYn: '',
    valdDlnCd: '',
    ccalCd: '',
    cardBrcoDcd: '',
    cardBrcoDnm: '',
    cardGdcd: '',
    trcdDcd: '',
    trcdDcdNm: '',
    nwCardDesgKcd: '',
    stlmBncd: '',
    stlmAcn: '',
    smsSrapYn: '',
    cardOfpsNo: '',
    crifUtlCosnYn: '',
    orriUtlCosnYn: '',
    crdtInofrCosnYn: '',
    orriOfrCosnYn: '',
    elcrAdvsIfrcCosnYn: '',
    crdTelSlcsYn: '',
    crdSmsSlcsYn: '',
    crdInwrSlcsYn: '',
    crdEmlSlcsYn: '',
    pdfUtlSlcsYn: '',
    pdfNmcpSrgnCosnYn: '',
    ilusPrvnInfoOffsYn: '',
    mblMsgSvcCosnYn: '',
    stlmDd: '',
    edpsCsn: '',
    csacIdntNo: '',
    bdsCd: '',
    csmnTeamCd: '',
    amslCstpSmsSndgDcd: '',
    amslCstpSmsSndgDcdNm: '',
    spaeZpcd: '',
    spaeZpcdBscAdr: '',
    spaeZpcdDtlAdr: '',
    spaeRdndDcd: '',
    spaeRdnmBscAdr: '',
    spaeRdnmDtlAdr: '',
    spaeBldnMngmNo: '',
    spaeTelLln: '',
    spaeTelTon: '',
    spaeTelIncsNo: '',
    rcepAddr: '',
    stlmDdTxt: '',
    ftpmTrcdYc: '',
    nchInsnSvcYn: '',
    nchInsnSvcNm: '',
    wbcsRlnmAltrNo: '',
    trnYmd: '',
    trhsSrn: '',
    newCard: '',
    pdlnCd: '',
    pdgrCd: '',
    transkeyUuidPwd: '',
    transkeyPwd: '',
    transkeyHmPwd: '',
    transkeyUuidCashPwd: '',
    transkeyCashPwd: '',
    transkeyHmCashPwd: '',
    transkeyUuidPinPwd: '',
    transkeyPinPwd: '',
    transkeyHmPinPwd: '',
    comboYn: '',
    brandNm: '',
    isChkCrdSamePwCshCrd: false,
    brllCardDcd: '',
    simpStlmSrapNo: '',
    stplOfrMcd: '',
    stplOfrMcdNm: '',
	alncMemoCon: '',
    iTravelArgee: false,

    innnSccType: '',
    sccYn: '',

    isIdciMndrOfrCoccd: false,
    isSingleCardDesign: false,
    cardDesignData: [
        {
            desgKcd: '',
            desgKNm: '',
            desgKSrc: '',
        },
    ],
    ftpmTrcdFuncYn: '',
    isFtpmTrcdYcFix: false,
    cardRcepBrNm: '',
    paymentDate: {
        isFix: false,
        stlmDd: '',
    },
    isDccRequired: false,
    studentCardYn: '',
    ovrsWonStlmCosnYn: '',
    cardChrcPa305: '',
    cardInfoLc022List: [
        {
            nfchCnvlDataCon: '',
            cnvlDataCon: '',
        },
    ],
}
